export const UserType = {
  COLLABORATOR: 'COLLABORATOR',
  OWNER: 'OWNER',
};
